import useSelectorData from '@/pages/dashboard/filterPageComponents/multiTimezone/hooks/useSelectorData'
import { getByTimeZoneTrendData } from '@/pages/dashboard/services/multiTimezone'
import { useState, useEffect } from 'react'

import Country from './Country'
import Zone from './Zone'
import {formatFilterValues} from "@/pages/dashboard/utils/utils";
interface MetricsTrendCardProps {
  loading?: boolean
  formValue?: any
  gameCode?: string
  selectMetrics?: any
}

export default function DAUTrendChart(props: MetricsTrendCardProps) {
  const { loading: filterLoading, formValue, gameCode, selectMetrics } = props
  const { type: timeZoneType } = useSelectorData()
  const [data, setData] = useState<any>(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(false)

  const update = ({
    formValue,
    gameCode,
    timeZoneType
  } = {} as any) => {
    const {
      rangeTime,
      // region,
      // zone,
      // channel,
      // system,
      // language,
      diff,
      timeType,
      ...filters
    } = formValue
    setLoading(true)
    getByTimeZoneTrendData({
      game_code: gameCode,
      start_time: rangeTime[0],
      end_time: rangeTime[1],
      period: 'daily',
      timezone_type: timeZoneType,
      metric: selectMetrics.value,
      filters: formatFilterValues(filters)
      // filters: {
      //   zone_list: zone,
      //   channel_list: channel,
      //   os_list: system,
      //   market_list: region?.markets,
      //   lang_list: language
      // },
    })
      .then((res) => {
        setData(res)
        setError(false)
      }).catch((err)=>[
        setError(err)
      ])
      .finally(() => {
        setLoading(false)
      })
  }
  
  useEffect(() => {
    if (filterLoading) return
    update({
      formValue,
      gameCode,
      timeZoneType
    })
  }, [formValue, filterLoading, selectMetrics?.value])

  return (
    <>
    {
      timeZoneType === 'country' ? 
        <Country {...props} data={data} loading={loading} error={error}/> :
        <Zone {...props} data={data} loading={loading} error={error}/>
    }
    </>
  )
}
